import { api } from "#src/api";

async function fetchShpxAssistData(jobId) {
  const { data, error } = await api
    .from("shpx_requested_pages")
    .select("*")
    .eq("job_id", jobId);

  if (error) {
    console.error("Error fetching SHPX Assist data:", error);
    return {};
  }

  return data.reduce((acc, page) => {
    if (!acc[page.document_id]) {
      acc[page.document_id] = {};
    }
    acc[page.document_id][page.page_id] = page;
    return acc;
  }, {});
}

async function updateShpxAssistData(
  pages,
  { organization_id, job_id, document_id, status },
) {
  const { data, error } = await api
    .from("shpx_requested_pages")
    .upsert(
      pages.map((page_id) => ({
        organization_id,
        job_id,
        document_id,
        page_id,
        status,
      })),
      { onConflict: "document_id,page_id" },
    )
    .select("*");

  return { data, error };
}

export { fetchShpxAssistData, updateShpxAssistData };
